import { createEntityAdapter } from '@reduxjs/toolkit';
import { NormalizedResourcesState } from 'services/api/resources/types';
import { Category, Model } from 'types/entities/Resources';

export const categoriesAdapter = createEntityAdapter<Category>({
  sortComparer: (a, b) => {
    const aHasIndex = hasIndex(a);
    const bHasIndex = hasIndex(b);

    if (aHasIndex && bHasIndex) {
      return a.index - b.index;
    }

    if (aHasIndex && !bHasIndex) {
      return -1; // a
    }

    if (!aHasIndex && bHasIndex) {
      return 1; // b
    }

    return a.name.localeCompare(b.name);
  },
});

function hasIndex(
  category: Category,
): category is Category & { index: number } {
  return typeof category.index === 'number';
}

export const modelsAdapter = createEntityAdapter<Model, string>({
  selectId: entity => entity.model,
  sortComparer: (a, b) => a.model.localeCompare(b.model),
});

export const initialResourcesState: NormalizedResourcesState = {
  categories: categoriesAdapter.getInitialState(),
  models: modelsAdapter.getInitialState(),
};
